<div
  class="field-container {{
    question?.displayFieldType | cleanElementSelector
  }} {{ question.lockType }}"
  [ngClass]="{
    hidden: !question?.isTab && question?.hidden && !showHiddenQuestion,
    nonEmpty: nonEmpty(question),
    cantEdit: question.lockType === 'hardLock' && !isSuperAdmin,
    lock:
      isLocked &&
      (question.lockType === 'hardLock' || question.lockType === 'softLock'),
    unlock: !isLocked
  }"
  [attr.data-test-ref]="'q' + question?.id?.toString()"
>
  @if (!question?.parentId && !isSmartForm) {
  <div class="lbl-container">
    <label
      (click)="labelClick(groupId, subgroup, question, (question?.answers)[0])"
      [ngClass]="{
        hasClick: labelClick,
        highlight: question?.id === inputQuestionId
      }"
      title="{{ labelTitle || undefined }}"
    >
      @if (showQuestionId) {
      <span>{{ question?.id }}.</span>
      }
      {{ question?.question }}
      @if (question?.showTag) {
      <span> {{ "tag" | transloco }} {{ question?.showTag }})</span>
      }@if (question?.debugLinks) {
      <span
        >{{ "link" | transloco }}
        <span class="link" (click)="goToSection('questions', question.id)">
          {{ "question" | transloco }} </span
        >-<span class="link" (click)="goToSection('calculations', question.id)">
          {{ "calc" | transloco }} </span
        >)</span
      >
      } @if (question.lockType === 'softLock' && isLocked) {
      <i class="lock icon" (click)="toggleLock()"></i>
      } @if (question.lockType === 'hardLock' && isLocked) {
      <i
        class="lock icon"
        [ngClass]="{ disabled: !isSuperAdmin }"
        (click)="toggleLock()"
      ></i>
      } @if (question.lockType === 'softLock' && !isLocked) {
      <i class="unlock icon" (click)="toggleLock()"></i>
      } @if (question.lockType === 'hardLock' && !isLocked) {
      <i
        class="unlock icon"
        [ngClass]="{ disabled: !isSuperAdmin }"
        (click)="toggleLock()"
      ></i>
      }
    </label>
    @if ((question.lockType === 'manualInput' || !isLocked) &&
    showOverRideQuestion(question)) {
    <i class="eraser icon" (click)="overRideAnswer(question)"></i>
    } @if (setGlobal && (formGroup?.controls)[question.id]?.value) {
    <app-global-answer
      [setGlobal]="setGlobal"
      [question]="question"
      [myFormControl]="getControl(question)"
      [isUnassignedPopulation]="isUnassignedPopulation"
    >
    </app-global-answer>
    }
  </div>
  }

  <div class="input-container">
    @if (question?.hint && !isSmartForm) {
    <div class="field-hint">
      {{ question?.hint }}
    </div>
    } @if (hasNotification) {
    <div class="dots">
      @if ( getControl(question).valid === false || hasNotification(
      'answerWarnings', question, null, (question?.answers)[0] ) ) {
      <div
        class="dot warning"
        [ngClass]="{
          active:
            getControl(question).valid === false ||
            hasNotification(
              'answerWarnings',
              question,
              null,
              (question?.answers)[0],
              true
            )
        }"
      ></div>
      } @if ( hasNotification('answerFlags', question, null,
      (question?.answers)[0]) ) {
      <div
        class="dot flag"
        [ngClass]="{
          active: hasNotification(
            'answerFlags',
            question,
            null,
            (question?.answers)[0],
            true
          )
        }"
      ></div>
      } @if ( hasNotification('comments', question, null,
      (question?.answers)[0]) ) {
      <div class="dot comment"></div>
      }
    </div>
    } @if (question?.displayFieldType === 'text') {
    <div>
      @if (question?.dataType === 'string') {
      <app-text-field
        [question]="question"
        [myFormControl]="getControl(question)"
        [disabled]="disabled"
        [autofocus]="autofocus"
        (blur)="onBlur()"
        [tabIndex]="tabIndex"
      ></app-text-field>
      } @if ( question?.dataType?.toLowerCase() === 'integer' ||
      question?.dataType?.toLowerCase() === 'float' ) {
      <app-number-field
        [question]="question"
        [myFormControl]="getControl(question)"
        [disabled]="disabled"
        [autofocus]="autofocus"
        (blur)="onBlur()"
        [tabIndex]="tabIndex"
      ></app-number-field>
      }
    </div>
    } @if (question?.displayFieldType === 'textarea') {
    <div>
      <app-text-area
        [question]="question"
        [myFormControl]="getControl(question)"
        [disabled]="disabled"
        [autofocus]="autofocus"
        (blur)="onBlur()"
        [tabIndex]="tabIndex"
      ></app-text-area>
    </div>
    } @if (question?.displayFieldType === 'checkbox') {
    <div>
      <app-checkbox-field
        [question]="question"
        [myFormControl]="getControl(question)"
        [disabled]="disabled"
        [autofocus]="autofocus"
        (blur)="onBlur()"
        [tabIndex]="tabIndex"
      ></app-checkbox-field>
    </div>
    } @if (question?.displayFieldType === 'radio') {
    <div>
      <app-radio-field
        [question]="question"
        [myFormControl]="getControl(question)"
        [radioName]="(groupId || 0).toString()"
        [disabled]="disabled"
        [tabIndex]="tabIndex"
      ></app-radio-field>
    </div>
    } @if (question?.displayFieldType === 'date picker') {
    <div>
      <app-date-field
        [question]="question"
        [myFormControl]="getControl(question)"
        [disabled]="disabled"
        [tabIndex]="tabIndex"
      ></app-date-field>
    </div>
    } @if (question?.displayFieldType === 'drop down') {
    <div>
      <app-dropdown-field
        [question]="question"
        [myFormControl]="getControl(question)"
        [disabled]="disabled"
        [tabIndex]="tabIndex"
      ></app-dropdown-field>
    </div>
    } @if (question?.displayFieldType === 'people') {
    <div>
      <app-dropdown-field
        [question]="question"
        [myFormControl]="getControl(question)"
        [disabled]="disabled"
        [tabIndex]="tabIndex"
      ></app-dropdown-field>
    </div>
    }
    <!-- <div *ngIf="question?.displayFieldType === 'image'">
          <app-image-field
            [question]="question"
            [myFormControl]="getControl(question)"
            [disabled]="disabled"
            [tabIndex]="tabIndex"
            [lockOnlyDisabledValue]="lockOnlyDisabledValue"
          ></app-image-field>
        </div> -->
    @if (question?.displayFieldType === 'file') {
    <div>
      <app-file-field
        [question]="question"
        [myFormControl]="getControl(question)"
        [disabled]="disabled"
        [tabIndex]="tabIndex"
        [lockOnlyDisabledValue]="lockOnlyDisabledValue"
      ></app-file-field>
    </div>
    }
  </div>
</div>
